import React, { createContext, useContext, useState, useCallback } from "react";
import { api, setToken } from "./api";

export interface User {
  id: string;
  email: string;
  nom_complet: string;
  role: "manager" | "consultant";
  initiales: string;
}

interface AuthCtx {
  user: User | null;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

const Ctx = createContext<AuthCtx>({ user: null, login: async () => {}, logout: () => {} });

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(() => {
    const raw = localStorage.getItem("nx_user");
    const token = localStorage.getItem("nx_token");
    if (raw && token) {
      setToken(token);
      return JSON.parse(raw);
    }
    return null;
  });

  const login = useCallback(async (email: string, password: string) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("nx_token", data.access_token);
    localStorage.setItem("nx_refresh", data.refresh_token);
    localStorage.setItem("nx_user", JSON.stringify(data.user));
    setToken(data.access_token);
    setUser(data.user);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("nx_token");
    localStorage.removeItem("nx_refresh");
    localStorage.removeItem("nx_user");
    setToken(null);
    setUser(null);
  }, []);

  return <Ctx.Provider value={{ user, login, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
